export const ONBOARDING_SWITCH = {
  personlia: 1,
  running: 2,
  first_preview: 3,
};
